import React from "react";
import Heroicon from "../Heroicon";

function EditButton({ condition = true, type, handleChange }) {
  return (
    <>
      {condition ? (
        <button
          type="button"
          className={`${
            condition
              ? "bg-purple-200 hover:bg-purple-300 text-purple-700"
              : "bg-gray-200 border border-gray-400 text-gray-500 cursor-default"
          } text-sm grid place-items-center rounded-lg ${
            type === "Edit" ? "w-10 h-10 p-0" : "py-2.5 px-4"
          }`}
          onClick={handleChange}
          aria-label={type}
        >
          {type === "Edit" ? (
            <Heroicon icon="o-pencil" style="w-4 h-4" />
          ) : (
            "Update"
          )}
        </button>
      ) : (
        <button
          type="button"
          className={`bg-gray-100 text-gray-400 cursor-default text-sm grid place-items-center rounded-lg ${
            type === "Edit" ? "w-10 h-10 p-0" : "py-2.5 px-4"
          }`}
          aria-label={type}
          disabled
        >
          {type === "Edit" ? (
            <Heroicon icon="o-pencil" style="w-4 h-4" />
          ) : (
            "Update"
          )}
        </button>
      )}
    </>
  );
}

export default EditButton;
